import React, { useMemo } from 'react';
import { BoundingBox } from '../../types';

interface HighlightOverlayProps {
  bbox: BoundingBox | null;
  canvasWidth: number;
  canvasHeight: number;
}

export const HighlightOverlay: React.FC<HighlightOverlayProps> = ({
  bbox,
  canvasWidth,
  canvasHeight,
}) => {
  const style = useMemo(() => {
    if (!bbox || bbox.length === 0 || canvasWidth === 0 || canvasHeight === 0) {
      return { display: 'none' };
    }

    const xs = bbox.map((v) => v.x);
    const ys = bbox.map((v) => v.y);

    const minX = Math.min(...xs) * canvasWidth;
    const minY = Math.min(...ys) * canvasHeight;
    const maxX = Math.max(...xs) * canvasWidth;
    const maxY = Math.max(...ys) * canvasHeight;

    const width = maxX - minX;
    const height = maxY - minY;

    return {
      left: `${minX}px`,
      top: `${minY}px`,
      width: `${Math.max(10, width)}px`,
      height: `${Math.max(10, height)}px`,
      display: 'block',
    };
  }, [bbox, canvasWidth, canvasHeight]);

  return <div id="highlightBox" style={style} />;
};
